import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home.vue'
import Login from '@/views/Login.vue'
import ChangePin from '@/views/ChangePin'
import ChangeEmail from '@/views/ChangeEmail'
import RequestResetPin from '@/views/RequestResetPin'
import ResetPin from '@/views/ResetPin'
import Logout from '@/views/Logout'
import store from '@/store'
import NotFound from '@/views/NotFound'
import LoginToken from '@/views/LoginToken'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/login_token',
      name: 'LoginToken',
      component: LoginToken
    },
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: { requiresAuth: true }
    },
    {
      path: '/cambiar_pin',
      name: 'ChangePin',
      component: ChangePin,
      meta: { parent: 'Home', requiresAuth: true }
    },
    {
      path: '/cambiar_correo_electronico',
      name: 'ChangeEmail',
      component: ChangeEmail,
      meta: { parent: 'Home', requiresAuth: true }
    },
    {
      path: '/solicitar_reset_pin',
      name: 'RequestResetPin',
      component: RequestResetPin,
      meta: { parent: 'Login' }
    },
    {
      path: '/reset_pin/:url',
      name: 'ResetPin',
      component: ResetPin,
      meta: { parent: 'Login' }
    },
    {
      path: '/logout',
      name: 'Logout',
      component: Logout,
      meta: { parent: 'Login' }
    },
    {
      path: '*',
      name: 'NotFound',
      component: NotFound,
      meta: { parent: 'Login' }
    }
  ]
})

router.beforeEach(async (to, from, next) => {
  // Prevent open redirect in ChangePin by removing the redirect query parameter
  // if the previous page wasn't Login
  if (from.name !== 'Login' && from.name !== 'LoginToken' && to.name === 'ChangePin' && to.query.redirect) {
    delete to.query.redirect
  }

  const requiresAuth = to.meta.requiresAuth

  // Is authorization data available?
  if (!store.getters['auth/isAuthSet']) {
    // Populate authentication data
    await store.dispatch('auth/restoreAuth', null, { root: true })
  }

  if (requiresAuth) {
    // Is logged in?
    if (!store.getters['auth/isLoggedIn']) {
      next({
        name: 'Login',
        query: { redirect: to.fullPath }
      })
      return // To avoid writing multiple 'next()'
    } else {
      // Force pin change
      if (store.state.auth.debeCambiarPin && to.name !== 'ChangePin') {
        next({
          name: 'ChangePin',
          query: { redirect: to.fullPath }
        })
        return // To avoid writing multiple 'next()'
      }
    }
  } else {
    // Is logged in?
    if (store.getters['auth/isLoggedIn']) {
      // Except for Login or Logout page
      if (to.name !== 'Login' && to.name !== 'Logout' && to.name !== 'NotFound' && to.name !== 'LoginToken') {
        // Redirect to Home page
        next({ name: 'Home' })
        return // To avoid writing multiple 'next()'
      }
    }
  }
  next()
})

export default router
